<form [formGroup]="form">
  <h5 style="text-align: left">{{ "addLP.5thStep.title" | translate }}</h5>

  <div class="form-group">
    <label class="label"
      >{{ "admin.locations.repository.sessionTimeOut" | translate }}
      <b>(minutes)</b> *</label
    >
    <div class="input-group">
      <input
        formControlName="sessionTimeoutInMinutes"
        class="form-control"
        type="number"
        required
        [placeholder]="'placeholder.chooseSessionTimeOut' | translate"
        [ngClass]="{
          'is-invalid':
            !form.get('sessionTimeoutInMinutes')?.valid &&
            form.get('sessionTimeoutInMinutes')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="
          !form.get('sessionTimeoutInMinutes')?.valid &&
          form.get('sessionTimeoutInMinutes')?.touched
        "
      >
        {{ "validation.sessionTimeoutInMinutes" | translate }}
      </div>
    </div>
  </div>

  <div class="form-group">
    <label class="label"
      >{{ "admin.locations.repository.routerBrand" | translate }} *</label
    >
    <div class="justify-content-center row">
      <div
        *ngFor="let item of routerBrand; let i = index"
        class="border-style ps-2 col-4 col-xxl-4"
      >
        <a
          type="button"
          class="card"
          (click)="addRemoveRouterBrand($event, item.id)"
        >
          <div
            class="card-body"
            [ngClass]="{
              'border-active rounded p-l-0': routerBrandExists(item.id)
            }"
          >
            <img
              class="img"
              width="50%"
              [ngClass]="{
                'active show': routerBrandExists(item.id)
              }"
              [src]="item.icon"
            />
            <div class="d-flex justify-content-center">
              {{ item.value }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>

  <div class="form-group">
    <div
      class="d-flex align-items-center justify-content-between"
      *ngIf="isRadiusSupported"
    >
      <label class="label"
        >{{ "admin.locations.repository.radiusEnabled" | translate }}*</label
      >
      <div class="media-body text-end icon-state">
        <label class="switch icon-state">
          <input formControlName="radiusEnabled" class="mode" type="checkbox" />
          <span class="switch-state"></span>
        </label>
      </div>
    </div>

    <ng-container *ngIf="isRadiusSupported && isRadiusEnabled">
      <div class="form-group">
        <label class="label"
          >{{ "admin.locations.repository.radUsername" | translate }} *</label
        >
        <div class="input-group">
          <input
            formControlName="radUsername"
            class="form-control"
            type="text"
            autocomplete="off"
            appIgnorePasswordManagers
            aria-required="true"
            [placeholder]="'placeholder.radUsername' | translate"
            [ngClass]="{
              'is-invalid': isRadiusCredentialMissing('radUsername')
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="isRadiusCredentialMissing('radUsername')"
          >
            {{ "validation.radUsername" | translate }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="label"
          >{{ "admin.locations.repository.radPassword" | translate }} *</label
        >
        <div class="input-group">
          <input
            formControlName="radPassword"
            class="form-control"
            [type]="showRadPassword ? 'text' : 'password'"
            appIgnorePasswordManagers
            required="true"
            placeholder="*********"
            [ngClass]="{
              'is-invalid': isRadiusCredentialMissing('radPassword')
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="isRadiusCredentialMissing('radPassword')"
          >
            {{ "validation.radPassword" | translate }}
          </div>
          <div
            class="show-hide"
            (click)="toggleRadPasswordVisibility()"
            onKeyPress
          >
            <span>{{
              (showRadPassword ? "password.cash" : "password.show") | translate
            }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</form>
